<template>
  <div>
    <div class="current-position">
      <img class="common-banner2" src="../assets/img/banner.png" alt="">
      <div class="current-position-text">
        <div class="common-container">
          <div class="current-position-logotext">Psychological Counseling</div>
        </div>
        <div class="common-container">
          当前位置: 首页  >  心理咨询  >  {{ detail_obj.title }}
        </div>
      </div>
    </div>
    <div class="survey-module">
      <div class="common-container justify-between">
        <div class="survey-module-right">
          <span class="deatil-back">
            <div class="deatil-back-title f-w">联系方式</div>
            <div class="deatil-back-action">{{ detail_obj.phone }}</div>
          </span>
          <div class="survey-module-right-title f-w justify-between">
            <span class="survey-module-right-title-left">{{ detail_obj.title }}</span>
            <span class="survey-module-right-title-right justify-end">{{ detail_obj.createTime }}</span>
          </div>
          <div class="survey-module-right-action">
            <div class="new-detail" v-html="detail_obj.content" v-if="detail_obj.content"></div>
            <el-empty class="survey-module-right-action-empty" v-else description="暂无内容"></el-empty>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {ConsultDetail} from "@/api/index";
export default {
  data(){
    return{
      detail_obj:{
        title:'',
        content:'',
        createTime:'',
        phone:''
      }
    }
  },
  created(){
    ConsultDetail({id:this.$route.query.detail_id}).then((res)=>{
      for(let key in this.detail_obj){
        this.detail_obj[key] = res.data[key]
      }
      this.detail_obj.content = this.detail_obj.content.replace(/<img/g, "<img style='max-width:100%;height:auto;'")
      this.detail_obj.content = this.detail_obj.content.replace(/<video/g, "<video style='max-width:100%;height:auto;'")
    })
  },
  
}
</script>
<style scoped lang="css" src="../assets/css/rem.css" />
<style scoped>

</style>
